import { useMemo } from "react";

import { useFlow } from "src/api/queries";
import type { LabelDictionaries } from "src/flow/analytics/m1/VisualizeMetrics/specialDomainScaling";

// Returns UUID→name maps for the identifier-style special domains
// (`flow_id`, `flow_version_id`) so charts in the Live Analytics chat can
// render names instead of UUIDs. The chat is always scoped to a single flow
// today; `flow_id` therefore only resolves the current flow's UUID and
// returns the UUID itself as a fallback for anything else.
//
// Archived versions are included because historical data can reference them.
export const useSpecialDomainLabels = (
  flowId: string,
  flowName: string,
): LabelDictionaries => {
  const { data: flow } = useFlow(flowId, { includeArchivedFlowVersions: true });

  return useMemo<LabelDictionaries>(
    () => ({
      flow_id: { [flowId]: flowName },
      flow_version_id: Object.fromEntries(
        (flow?.versions ?? []).map((v) => [v.id, v.name]),
      ),
    }),
    [flow?.versions, flowId, flowName],
  );
};
